import dayjs, { Dayjs } from 'dayjs';
import { DateRange } from '../types';

export function normalize(a: Dayjs, b: Dayjs): DateRange {
  return a.isAfter(b, 'day')
    ? [b.startOf('day'), a.endOf('day')]
    : [a.startOf('day'), b.endOf('day')];
}

export function formatButtonLabel(
  buttonLabel: string,
  value: DateRange,
): string {
  if (buttonLabel) return buttonLabel;
  if (!value[0] || !value[1]) return 'Select Duration';

  const start = value[0];
  const end = value[1];

  if (
    start.isSame(dayjs().startOf('month'), 'day') &&
    end.isSame(dayjs().endOf('month'), 'day')
  ) {
    return 'This Month';
  }

  if (
    start.isSame(end, 'month') &&
    start.isSame(start.startOf('month'), 'day') &&
    end.isSame(end.endOf('month'), 'day')
  ) {
    return start.format('MMMM YYYY');
  }

  if (start.isSame(end, 'day')) {
    return start.format('MMM DD, YYYY');
  }

  return `${start.format('MMM DD')} - ${end.format('MMM DD, YYYY')}`;
}
